const ABSOLUTE_TOLERANCE_EUR = 0.02;
const RELATIVE_TOLERANCE = 0.01;

export interface DeliveryLineAmounts {
  unitPrice?: number | null;
  quantity?: number | null;
  lineTotal?: number | null;
}

function isUsableNumber(value: number | null | undefined): value is number {
  return typeof value === 'number' && Number.isFinite(value);
}

/**
 * True when a DDT line carries both unit price and line total but
 * `unitPrice × quantity` does not match the printed total beyond
 * `max(0.02 €, 1%)` of the total. Signals a likely misread quantity
 * (e.g. packages read as weight); it is a hint, never a validation error.
 * Without both amounts nothing can be said, so it returns false.
 */
export function isLineAmountInconsistent(line: DeliveryLineAmounts): boolean {
  const { unitPrice, quantity, lineTotal } = line;
  if (!isUsableNumber(unitPrice) || !isUsableNumber(lineTotal) || !isUsableNumber(quantity)) {
    return false;
  }
  const tolerance = Math.max(ABSOLUTE_TOLERANCE_EUR, Math.abs(lineTotal) * RELATIVE_TOLERANCE);
  return Math.abs(unitPrice * quantity - lineTotal) > tolerance + Number.EPSILON;
}
